import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from "../../mutation-types";
import poApi from "@/api/po";

const defaultState = () => ({
	dataWarehouse: [],
    dataProduk: [],
    dataBankAccount: [],
    dataBank: [],
});

const state = defaultState();

const mutations = {
	reset(state) {
		Object.assign(state, defaultState());
	},
	setDataWarehouse(state, data) {
		state.dataWarehouse = data
	},
    setDataProduk(state, data) {
		state.dataProduk = data.map(el => {
			el.selected = false
			el.quantity = '1'
			return el
		});
	},
    setDataBankAccount(state, data) {
		state.dataBankAccount = data
	},
	setDataBank(state, data) {
		state.dataBank = data
	},
}

const actions = {
	getWarehouse({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		poApi.getWarehouse(param).then(({ data: { data } }) => {
			commit("setDataWarehouse", data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
    getProduct({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		poApi.getProduct(param).then(({ data: { data } }) => {
			commit("setDataProduk", data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
    getBankAccount({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		poApi.getBankAccount(param).then(({ data: { data } }) => {
			commit("setDataBankAccount", data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
	savePO({ commit }, value) {
		return new Promise((resolve, reject) => {
			commit(PROGRESS_START, null, { root: true });
			poApi.savePO(value).then(({ data }) => {
				commit(PROGRESS_FINISH, null, { root: true });
				resolve(data.message)
			}).catch( err => {
				commit(PROGRESS_FAIL, null, { root: true })
				reject(err.response)
			});
		})
	},
	getBank({ commit }, param) {
		commit(PROGRESS_START, null, { root: true });
		poApi.getBank(param).then(({ data: { data } }) => {
			commit("setDataBank", data.results);
			commit(PROGRESS_FINISH, null, { root: true });
		}).catch(() => {
			commit(PROGRESS_FAIL, null, { root: true });
		});
	},
}

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};